import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ButtonModule } from '@fino-ui/button';
import { SubmittableForm } from '@fino-ui/forms';
import { FinoInputModule } from '@fino-ui/input';
import { BaseModalComponent } from '@fino-ui/modal';
import { TranslationModule } from '@fino-ui/translation';

@Component({
  selector: 'app-credentials',
  templateUrl: './credentials.component.html',
  styleUrl: './credentials.component.sass',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    FinoInputModule,
    ButtonModule,
    TranslationModule,
  ],
})
export class CredentialsComponent
  extends BaseModalComponent<
    {
      link: string;
      username: string;
      password: string;
      atruviaSystem: boolean;
    },
    number
  >
  implements OnInit
{
  constructor() {
    super();
    Object.assign(this, this.data ?? {});
  }

  link: string;
  username: string;
  password: string;
  atruviaSystem: boolean;

  titleParams: any = { system: '' };

  ngOnInit(): void {
    this.form.setValue({
      link: this.link,
      username: this.username,
      password: this.password,
    });

    this.titleParams = { system: this.atruviaSystem ? 'Anonymisiertes' : '' };
  }

  form = new SubmittableForm({
    link: new FormControl({ value: '', disabled: true }, [Validators.required]),
    username: new FormControl({ value: '', disabled: true }, [
      Validators.required,
    ]),
    password: new FormControl({ value: '', disabled: true }, [
      Validators.required,
    ]),
  });

  open() {
    window.open(this.link, '_blank').focus();
  }

  abort() {
    this.close();
  }
}
